import { useMutation } from "@tanstack/react-query"

import { invalidateSessionMedia } from "../invalidateSessionMedia"
import { trpcOptions } from "../trpc"

export function useSkipVideo(sessionId: string) {
  return useMutation(trpcOptions.app.skipVideo.mutationOptions({ onSuccess: () => invalidateSessionMedia(sessionId) }))
}
